(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  // ========== JAVASCRIPT ==========
  
  (function() {
    'use strict';
    
    const section = document.querySelector('.north-shore-product-page');
    if (!section) return;
    
    // ---- QUANTITY SELECTOR ----
    const qtySelector = section.querySelector('[data-quantity-selector]');
    const qtyInput = section.querySelector('[data-quantity-input]');
    if (qtySelector) {
      const qtyDisplay = qtySelector.querySelector('[data-qty-display]');
      const decreaseBtn = qtySelector.querySelector('[data-qty-decrease]');
      const increaseBtn = qtySelector.querySelector('[data-qty-increase]');
      let qty = 1;
      
      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function(e) {
          e.preventDefault();
          if (qty > 1) {
            qty--;
            qtyDisplay.textContent = qty;
            if (qtyInput) qtyInput.value = qty;
          }
        });
      }
      
      if (increaseBtn) {
        increaseBtn.addEventListener('click', function(e) {
          e.preventDefault();
          qty++;
          qtyDisplay.textContent = qty;
          if (qtyInput) qtyInput.value = qty;
        });
      }
    }
    
    // ---- CENTRAL VARIANT SELECTION STATE ----
    const packCards = Array.from(section.querySelectorAll('[data-pack]'));
    const mainPriceEl = section.querySelector('[data-product-price]');
    const comparePriceEl = section.querySelector('[data-product-compare-price]');
    const compareWrapper = section.querySelector('[data-product-compare-wrapper]');
    const variantInput = section.querySelector('[data-selected-variant-id]');
    const mainImageEl = section.querySelector('[data-gallery-main-image]');

    function getThumbs() {
      return Array.from(section.querySelectorAll('[data-thumb]'));
    }

    function findCardByVariantId(variantId) {
      return packCards.find(function(c) { return c.dataset.variantId === String(variantId); });
    }

    function findThumbByMediaId(mediaId) {
      if (!mediaId) return null;
      return getThumbs().find(function(t) { return t.dataset.mediaId === String(mediaId); });
    }

    function findCardByMediaId(mediaId) {
      if (!mediaId) return null;
      return packCards.find(function(c) { return c.dataset.mediaId && c.dataset.mediaId === String(mediaId); });
    }

    function selectVariant(variantId, isUserClick) {
      if (!variantId) return;
      const card = findCardByVariantId(variantId);
      if (!card) return;

      const price = card.dataset.price;
      const comparePrice = card.dataset.comparePrice;
      const mediaId = card.dataset.mediaId;
      const packImageUrl = card.dataset.image;

      // 1. Pack card active state
      packCards.forEach(function(c) { c.classList.remove('selected'); });
      card.classList.add('selected');

      // 2. Hidden variant id input (drives Add to Cart)
      if (variantInput) {
        variantInput.value = variantId;
      }

      // 3. Price / compare price
      if (price && mainPriceEl) {
        mainPriceEl.textContent = price;
      }
      if (compareWrapper) {
        if (comparePrice && comparePrice.trim() !== '') {
          if (comparePriceEl) comparePriceEl.textContent = comparePrice;
          compareWrapper.style.display = 'inline-block';
        } else {
          compareWrapper.style.display = 'none';
        }
      }

      // 4. Thumbnail & Main Image sync
      const thumbs = getThumbs();
      const matchedThumb = findThumbByMediaId(mediaId);

      thumbs.forEach(function(t) { t.classList.remove('active'); });

      if (isUserClick) {
        const cardImgEl = card.querySelector('.pack-img-wrapper img');
        const cardImgSrc = (packImageUrl && packImageUrl.trim() !== '') ? packImageUrl : (cardImgEl ? cardImgEl.getAttribute('src') : '');

        if (cardImgSrc && cardImgSrc.trim() !== '') {
          if (mainImageEl) {
            mainImageEl.setAttribute('src', cardImgSrc);
          }
          if (matchedThumb) {
            matchedThumb.classList.add('active');
          }
        } else if (matchedThumb) {
          matchedThumb.classList.add('active');
          const fullSrc = matchedThumb.getAttribute('data-full-src') || matchedThumb.getAttribute('src');
          if (fullSrc && mainImageEl) {
            mainImageEl.setAttribute('src', fullSrc);
          }
        }
      } else {
        if (matchedThumb) {
          matchedThumb.classList.add('active');
          const fullSrc = matchedThumb.getAttribute('data-full-src') || matchedThumb.getAttribute('src');
          if (fullSrc && mainImageEl) {
            mainImageEl.setAttribute('src', fullSrc);
          }
        } else if (thumbs.length > 0) {
          thumbs[0].classList.add('active');
          const fullSrc = thumbs[0].getAttribute('data-full-src') || thumbs[0].getAttribute('src');
          if (fullSrc && mainImageEl) {
            mainImageEl.setAttribute('src', fullSrc);
          }
        }
      }

      if (window.nsRefreshGalleryScrollTrigger) window.nsRefreshGalleryScrollTrigger();
    }

    if (packCards.length) {
      packCards.forEach(function(card) {
        card.addEventListener('click', function() {
          selectVariant(card.dataset.variantId, true);
        });
      });
    }

    // ---- PRODUCT FORM / ADD TO CART ----
    const addToCartBtn = section.querySelector('[data-add-to-cart]');
    const productForm = section.querySelector('[data-product-form]');

    function handleAddToCart(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      const variantInputEl = section.querySelector('[data-selected-variant-id]');
      const qtyInputEl = section.querySelector('[data-quantity-input]');
      
      let variantId = variantInputEl ? variantInputEl.value : '';
      let qtyVal = qtyInputEl ? qtyInputEl.value : 1;

      if (!variantId) {
        const selectedPackCard = section.querySelector('[data-pack].selected');
        if (selectedPackCard) {
          variantId = selectedPackCard.dataset.variantId;
          if (variantInputEl) variantInputEl.value = variantId;
        }
      }

      if (addToCartBtn) {
        addToCartBtn.innerHTML = 'Redirecting to Cart...';
        addToCartBtn.disabled = true;
      }

      const cartRedirectUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root + 'cart' : '/cart';
      const cartAddUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js';

      const formData = new FormData();
      if (variantId) formData.append('id', variantId);
      formData.append('quantity', qtyVal);

      fetch(cartAddUrl, {
        method: 'POST',
        body: formData
      })
      .then(function() {
        window.location.href = cartRedirectUrl;
      })
      .catch(function(err) {
        console.warn('AJAX add to cart fallback, submitting form natively to redirect to cart:', err);
        if (productForm) {
          productForm.submit();
        } else {
          window.location.href = cartRedirectUrl;
        }
      });
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', handleAddToCart);
    }

    if (productForm) {
      productForm.addEventListener('submit', handleAddToCart);
    }

    // ---- SHOP PAY BUTTON ----
    const shopPayBtn = section.querySelector('[data-shop-pay]');
    if (shopPayBtn) {
      shopPayBtn.addEventListener('click', function(e) {
        e.preventDefault();
        handleAddToCart();
      });
    }
    
    // ---- PRODUCT GALLERY CAROUSEL / THUMBNAILS ----
    let currentGalleryIndex = 0;

    function updateGalleryByIndex(index) {
      const thumbs = getThumbs();
      if (!thumbs.length || !mainImageEl) return;
      currentGalleryIndex = (index + thumbs.length) % thumbs.length;
      const targetThumb = thumbs[currentGalleryIndex];
      if (!targetThumb) return;

      const ownerCard = findCardByMediaId(targetThumb.dataset.mediaId);
      if (ownerCard) {
        selectVariant(ownerCard.dataset.variantId);
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        targetThumb.classList.add('active');
        const fullSrc = targetThumb.getAttribute('data-full-src') || targetThumb.getAttribute('src');
        if (fullSrc) {
          mainImageEl.setAttribute('src', fullSrc);
        }
        targetThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        return;
      }

      thumbs.forEach(function(t) { t.classList.remove('active'); });
      targetThumb.classList.add('active');
      const fullSrc = targetThumb.getAttribute('data-full-src') || targetThumb.getAttribute('src');
      if (fullSrc) {
        mainImageEl.setAttribute('src', fullSrc);
      }
      targetThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    function bindThumbs() {
      const thumbs = getThumbs();
      thumbs.forEach(function(thumb, index) {
        thumb.addEventListener('click', function() {
          updateGalleryByIndex(index);
        });
      });
    }
    bindThumbs();

    const prevBtns = section.querySelectorAll('[data-gallery-prev]');
    const nextBtns = section.querySelectorAll('[data-gallery-next]');

    prevBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        updateGalleryByIndex(currentGalleryIndex - 1);
      });
    });

    nextBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        updateGalleryByIndex(currentGalleryIndex + 1);
      });
    });

    // ---- INITIALIZE ON PAGE LOAD ----
    (function initSelection() {
      const preSelectedCard = section.querySelector('[data-pack].selected') || packCards[0];
      if (preSelectedCard && preSelectedCard.dataset.variantId) {
        selectVariant(preSelectedCard.dataset.variantId, false);
      }
      const thumbs = getThumbs();
      if (thumbs.length > 0 && mainImageEl) {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumbs[0].classList.add('active');
        const firstSrc = thumbs[0].getAttribute('data-full-src') || thumbs[0].getAttribute('src');
        if (firstSrc) {
          mainImageEl.setAttribute('src', firstSrc);
        }
      }
    })();

    // ---- REAL REACTIONS CAROUSEL SLIDER ----
    const reactionsTrack = section.querySelector('[data-reactions-track]');
    const reactionsPrev = section.querySelector('[data-reactions-prev]');
    const reactionsNext = section.querySelector('[data-reactions-next]');

    if (reactionsTrack && reactionsPrev && reactionsNext) {
      reactionsPrev.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const cardWidth = reactionsTrack.querySelector('.reaction-card')?.offsetWidth || 230;
        reactionsTrack.scrollBy({ left: -(cardWidth + 16) * 2, behavior: 'smooth' });
      });

      reactionsNext.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const cardWidth = reactionsTrack.querySelector('.reaction-card')?.offsetWidth || 230;
        reactionsTrack.scrollBy({ left: (cardWidth + 16) * 2, behavior: 'smooth' });
      });
    }

    // ---- REACTION CARD VIDEO PLAY ----
    const reactionCards = section.querySelectorAll('[data-reaction-card]');
    let modal = null;
    let currentVideo = null;
    
    function createModal() {
      if (modal) return modal;
      modal = document.createElement('div');
      modal.className = 'ns-video-modal';
      modal.innerHTML = `
        <div class="modal-content">
          <button class="close-modal">&times;</button>
          <video id="ns-video-player" controls playsinline preload="metadata"></video>
        </div>
      `;
      document.body.appendChild(modal);
      
      const closeBtn = modal.querySelector('.close-modal');
      closeBtn.addEventListener('click', closeModal);
      modal.addEventListener('click', function(e) {
        if (e.target === modal) closeModal();
      });
      
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeModal();
      });
      
      return modal;
    }
    
    function openModal(videoUrl) {
      const modalEl = createModal();
      const videoPlayer = modalEl.querySelector('#ns-video-player');
      
      if (currentVideo) {
        currentVideo.pause();
        currentVideo.currentTime = 0;
      }
      
      videoPlayer.src = videoUrl;
      videoPlayer.load();
      currentVideo = videoPlayer;
      
      modalEl.classList.add('open');
      videoPlayer.play().catch(function(err) {
        console.log('Autoplay blocked or waiting for user interaction');
      });
    }
    
    function closeModal() {
      if (modal) {
        modal.classList.remove('open');
        const videoPlayer = modal.querySelector('#ns-video-player');
        if (videoPlayer) {
          videoPlayer.pause();
        }
        if (currentVideo) {
          currentVideo = null;
        }
      }
    }
    
    if (reactionCards.length) {
      reactionCards.forEach(function(card) {
        card.addEventListener('click', function(e) {
          if (e.target.closest('.reactions-arrow')) return;

          const videoUrl = card.dataset.videoUrl;
          if (videoUrl && videoUrl.trim() !== '') {
            openModal(videoUrl);
          } else {
            showToast('No video available for this reaction');
          }
        });
      });
    }

    // ---- ACCORDION ----
    const accordionItems = section.querySelectorAll('[data-accordion-item]');
    if (accordionItems.length) {
      accordionItems.forEach(function(item) {
        const header = item.querySelector('[data-accordion-header]');
        if (header) {
          header.addEventListener('click', function() {
            item.classList.toggle('open');
            if (window.nsRefreshGalleryScrollTrigger) window.nsRefreshGalleryScrollTrigger();
          });
        }
      });
    }

    // ---- HELPER: TOAST NOTIFICATION ----
    function showToast(message) {
      let toastContainer = document.querySelector('.ns-toast-container');
      if (!toastContainer) {
        toastContainer = document.createElement('div');
        toastContainer.className = 'ns-toast-container';
        toastContainer.style.cssText = `
          position: fixed;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 9999;
          max-width: 90%;
          width: 380px;
        `;
        document.body.appendChild(toastContainer);
      }
      
      const toast = document.createElement('div');
      toast.className = 'ns-toast';
      toast.style.cssText = `
        background: var(--ns-navy, #0b1a48);
        color: #fff;
        padding: 14px 20px;
        border-radius: 8px;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        box-shadow: 0 4px 20px rgba(0,0,0,0.2);
        margin-bottom: 10px;
        transition: opacity 0.3s;
      `;
      toast.textContent = message;
      
      toastContainer.appendChild(toast);
      
      setTimeout(function() {
        toast.style.opacity = '0';
        setTimeout(function() {
          toast.remove();
        }, 300);
      }, 3000);
    }

    console.log('North Shore Product Page Loaded.');
  })();

  // ========================================================
  // ---- GALLERY PIN (GSAP ScrollTrigger, desktop only) ----
  // ========================================================
  // (function() {
  //   'use strict';

  //   const HEADER_OFFSET = 80;
  //   const nsPinRegistry = new WeakMap();

  //   function loadGSAP(callback) {
  //     if (window.gsap && window.ScrollTrigger) {
  //       callback();
  //       return;
  //     }
  //     if (window.__nsGsapLoading) {
  //       window.__nsGsapLoading.push(callback);
  //       return;
  //     }
  //     window.__nsGsapLoading = [callback];

  //     const gsapScript = document.createElement('script');
  //     gsapScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
  //     gsapScript.onload = function() {
  //       const stScript = document.createElement('script');
  //       stScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
  //       stScript.onload = function() {
  //         gsap.registerPlugin(ScrollTrigger);
  //         window.__nsGsapLoading.forEach(function(cb) { cb(); });
  //         window.__nsGsapLoading = null;
  //       };
  //       document.head.appendChild(stScript);
  //     };
  //     document.head.appendChild(gsapScript);
  //   }

  //   function initGalleryPin(sectionEl) {
  //     if (nsPinRegistry.has(sectionEl)) return;

  //     const gallery = sectionEl.querySelector('.gallery');
  //     const productInfo = sectionEl.querySelector('.product-info');
  //     const productSection = sectionEl.querySelector('.product-section');
  //     if (!gallery || !productInfo || !productSection) return;

  //     const mm = gsap.matchMedia();

  //     mm.add('(min-width: 992px)', function() {
  //       const galleryHeight = gallery.offsetHeight;
  //       const infoHeight = productInfo.offsetHeight;

  //       if (infoHeight <= galleryHeight) {
  //         return;
  //       }

  //       const st = ScrollTrigger.create({
  //         trigger: productSection,
  //         start: 'top top+=' + HEADER_OFFSET,
  //         end: function() {
  //           const distance = productInfo.offsetHeight - gallery.offsetHeight;
  //           return '+=' + Math.max(distance, 0);
  //         },
  //         pin: gallery,
  //         pinSpacing: false,
  //         anticipatePin: 1,
  //         invalidateOnRefresh: true
  //       });

  //       return function() {
  //         st.kill();
  //       };
  //     });

  //     nsPinRegistry.set(sectionEl, mm);
  //   }

  //   function destroyGalleryPin(sectionEl) {
  //     const mm = nsPinRegistry.get(sectionEl);
  //     if (mm) {
  //       mm.revert();
  //       nsPinRegistry.delete(sectionEl);
  //     }
  //   }

  //   function refreshAll() {
  //     if (window.ScrollTrigger) ScrollTrigger.refresh();
  //   }
  //   window.nsRefreshGalleryScrollTrigger = refreshAll;

  //   function initAllSections() {
  //     document
  //       .querySelectorAll('[data-section-type="north-shore-product-page"]')
  //       .forEach(initGalleryPin);
  //   }

  //   loadGSAP(function() {
  //     initAllSections();

  //     window.addEventListener('load', function() {
  //       setTimeout(refreshAll, 300);
  //     });

  //     document
  //       .querySelectorAll('[data-section-type="north-shore-product-page"] img')
  //       .forEach(function(img) {
  //         if (!img.complete) img.addEventListener('load', refreshAll, { once: true });
  //       });

  //     let resizeTimer;
  //     window.addEventListener('resize', function() {
  //       clearTimeout(resizeTimer);
  //       resizeTimer = setTimeout(refreshAll, 200);
  //     });
  //   });

  //   document.addEventListener('shopify:section:load', function(e) {
  //     const sectionEl = e.target.querySelector('[data-section-type="north-shore-product-page"]');
  //     if (!sectionEl) return;
  //     if (window.gsap && window.ScrollTrigger) {
  //       initGalleryPin(sectionEl);
  //       refreshAll();
  //     } else {
  //       loadGSAP(function() {
  //         initGalleryPin(sectionEl);
  //         refreshAll();
  //       });
  //     }
  //   });

  //   document.addEventListener('shopify:section:unload', function(e) {
  //     const sectionEl = e.target.querySelector('[data-section-type="north-shore-product-page"]');
  //     if (sectionEl) destroyGalleryPin(sectionEl);
  //   });

  //   document.addEventListener('shopify:section:select', refreshAll);
  //   document.addEventListener('shopify:section:deselect', refreshAll);
  //   document.addEventListener('shopify:block:select', refreshAll);
  //   document.addEventListener('shopify:block:deselect', refreshAll);
  // })();

  // ========================================================
  // ---- WATCH HOW IT WORKS BUTTON + VIDEO POPUP/MODAL ----
  // ========================================================
  (function() {
    'use strict';

    const allSections = document.querySelectorAll('.north-shore-product-page[data-section-type="north-shore-product-page"]');

    allSections.forEach(function(sectionEl) {
      if (sectionEl.dataset.nsWatchVideoBound === 'true') return;
      sectionEl.dataset.nsWatchVideoBound = 'true';

      const watchBtn = sectionEl.querySelector('[data-watch-video]');
      if (!watchBtn) return;

      const videoModal = sectionEl.querySelector('[data-watch-video-modal]');

      if (videoModal) {
        const videoEl = videoModal.querySelector('video');

        function openWatchVideoModal() {
          videoModal.classList.add('is-open');
          document.body.style.overflow = 'hidden';

          if (videoEl) {
            videoEl.currentTime = 0;
            const playPromise = videoEl.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(function() {
              });
            }
          }
        }

        function closeWatchVideoModal() {
          videoModal.classList.remove('is-open');
          document.body.style.overflow = '';

          if (videoEl) {
            videoEl.pause();
            videoEl.currentTime = 0;
          }
        }

        watchBtn.addEventListener('click', function(e) {
          e.preventDefault();
          openWatchVideoModal();
        });

        videoModal.addEventListener('click', function(e) {
          if (e.target.closest('[data-watch-video-close]')) {
            e.preventDefault();
            closeWatchVideoModal();
          }
        });

        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && videoModal.classList.contains('is-open')) {
            closeWatchVideoModal();
          }
        });
      } else {
        watchBtn.addEventListener('click', function(e) {
          e.preventDefault();
          const reactionsSection = sectionEl.querySelector('.reactions-section');
          if (reactionsSection) {
            reactionsSection.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }
    });
  })();

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-reviews-carousel]').forEach(function(carousel) {
      const track = carousel.querySelector('[data-reviews-track]');

      if (!track || track.dataset.cloned === 'true') return;

      const cards = Array.from(track.children);

      if (cards.length === 0) return;

      cards.forEach(function(card) {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      track.dataset.cloned = 'true';
    });
  });

  } catch(e) { console.error(e); }
})();
})();
